export enum TypesPermission {
  RTAEXPORTSCORES = 4008,
  RTAEXPORTSCORENAME = 'RtaExportScores',
  RTAEXPORTREPORTS = 4011,
  RTAEXPORTREPORTSNAME = 'RtaExportReports'
}

export enum TestWithModels {
  reasoningTest = 25
}
